<template>
    <confirmation-modal titleKey="admin.user.action.updateRole" :confirm="confirm" :valid="valid">
      <wo-region v-if="roles">
        <wo-label v-t="'companyUserPermission.permission'" />
        <po-selector v-model="selectedRole" :options="roles"/>
      </wo-region>
    </confirmation-modal>
</template>

<script>

import { mapState } from 'vuex'

import { userRepository } from '@/repository/identity'
import { enumerationRepository } from '@/repository/enumeration'

import { User, UserRoleEnum } from '@/model/identity'

import ConfirmationModal from '@/components/modal/ConfirmationModal'

export default {
  components: { ConfirmationModal },
  props: {
    user: User
  },
  data () {
    return {
      selectedRole: undefined
    }
  },
  computed: mapState({
    roles: state => state.enumeration[UserRoleEnum.id],
    valid () {
      return !!this.selectedRole
    }
  }),
  created () {
    this.selectedRole = this.user.role
    this.$store.dispatch(enumerationRepository.find, UserRoleEnum)
  },
  methods: {
    confirm () {
      const action = {
        action: 'update-role',
        role: this.selectedRole.id
      }
      return this.$store.dispatch(userRepository.execute, { entity: this.user, action: action })
    }
  }
}
</script>
